module.exports = __webpack_public_path__ + "img/pad_banner.5794cff4.png";